const navBtn = document.querySelector('#navBtn');
const nav = document.querySelector('#nav');
const secondaryNavLinks = document.querySelectorAll('.secondaryNavLink');
const navImage = document.querySelector('#navImage');
const navListBtns = document.querySelectorAll('.navListBtn');
const searchContainer = document.querySelector('#searchContainer');
const searchTrigger = document.querySelector('#searchTrigger');
const searchAgain = document.querySelector('#search-again');
const scrollBtn = document.querySelector('.scrollBtn');
const heroCtaBtn = document.querySelector('.heroCtaBtn');
const headerWrapper = document.querySelector('.header-wrapper')

if (navBtn) {

	navBtn.addEventListener('click', () => {
		navBtn.classList.toggle('is-active');
		nav.classList.toggle('is-active');
		searchContainer.classList.toggle('is-active');
	})
}

if (navListBtns) {

	navListBtns.forEach((item) => {
		item.addEventListener('click', () => {
			item.classList.toggle('is-active');
			item.nextElementSibling.classList.toggle('is-active');
		})
	})
}

if (secondaryNavLinks) {

	secondaryNavLinks.forEach((item) => {
		const image = item.dataset.image;

		if (image) {
			item.addEventListener('mouseover', () => {
				navImage.src = image;
			})
		}
	})
}

if (searchTrigger) {
	searchTrigger.addEventListener('click', () => {
		activeSearchContainer()
	});
}

if (searchAgain) {
	searchAgain.addEventListener('click', () => {
		activeSearchContainer()
	});
}

function activeSearchContainer() {
	if (searchTrigger) {
		searchTrigger.classList.toggle('is-active');
	}

	if (searchContainer) {
		searchContainer.classList.toggle('is-active');
	}
}

if(scrollBtn) {
	const scrollTarget = document.getElementById('scroll-target')
	scrollBtn.addEventListener('click', ()=> {
		scrollTarget.scrollIntoView({ behavior: "smooth", block: "start" })
	})
}

if(heroCtaBtn) {
	heroCtaBtn.addEventListener('click', (e)=> {
		e.preventDefault();
		const targetId = e.currentTarget.getAttribute('data-targetId');
		const scrollTarget = document.getElementById(targetId.substring(1));
		scrollTarget.scrollIntoView({ behavior: "smooth", block: "start" })
	});
}

if(headerWrapper) {

	function scrollEventThrottle(fn) {
		let lastKownScrollPosition = 0;
		let ticking = false;
		window.addEventListener("scroll", function () {
			let previousKnownScrollPosition = lastKownScrollPosition;
			lastKownScrollPosition = window.scrollY;
			if (!ticking) {
				window.requestAnimationFrame(function () {
					fn(lastKownScrollPosition, previousKnownScrollPosition);
					ticking = false;
				});
				ticking = true;
			}
		});
	}

	scrollEventThrottle((scrollPos, previousScrollPos) => {
		// prevent triggering animation on safari scroll bounce
		if (window.scrollY < 46) {
			headerWrapper.classList.remove('is-scrolled')
			return;
		}

		if (previousScrollPos > scrollPos) {
			headerWrapper.classList.remove('is-scrolled');
		} else {
			headerWrapper.classList.add('is-scrolled');
		}
	});
}
